import { yup } from '@guiker/shared-framework'

export const resolveInsufficientFundFlaggedPayloadSchema = yup.object({
  publicToken: yup.string(),
  bankAccountId: yup.string(),
})
